import type { ExternalTaskConcrete } from '../../compliance-shared/types/compliance';
import { promptModal } from '@/components/modals/PromptModal.vue';
import { actions } from '@/services/actions';
import { alertModal } from '@/components/modals/AlertModal.vue';
import { toast } from '@/components/util/toast';

export async function determinationComplianceIssueResolve(
  externalTaskID: ExternalTaskConcrete['externalTaskID'] | ExternalTaskConcrete['externalTaskID'][],
): Promise<boolean> {
  const explanation = await promptModal({
    title: 'Resolve Applicability Tool compliance issue',
    message: `Please explain how the issue was resolved:`,
    choices: [
      { label: 'Cancel', value: false, icon: 'fa-xmark', variant: 'outline' },
      { label: 'Mark as resolved', value: true, icon: 'fa-check', variant: 'success' },
    ],
    type: 'textarea',
  });

  if (!explanation) {
    return false;
  }

  try {
    if (Array.isArray(externalTaskID)) {
      for (const id of externalTaskID) {
        await actions.externalTask.determinationComplianceIssueResolve(id, explanation);
      }
    } else {
      await actions.externalTask.determinationComplianceIssueResolve(externalTaskID, explanation);
    }
  } catch (e: any) {
    await alertModal({
      title: 'An error occurred while trying to mark this issue as resolved.',
      message: 'Error was: ' + e.message,
    });
    return false;
  }

  toast({ type: 'success', message: 'Issue marked as resolved in Applicability Tool.' });
  return true;
}
